import React from 'react'

import * as Sentry from '@sentry/react'

import NotFound from '../NotFound/NotFound'

export default class SentryErrorBoundary extends React.Component<{ children: React.ReactNode }> {
  state = {
    isError: false,
  }

  static getDerivedStateFromError() {
    return { isError: true }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error(error, errorInfo)
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo)
      scope.setTag('ui_state', 'page crash')
      const eventId = Sentry.captureException(error)
      this.setState({ eventId })
    })
  }

  render() {
    const { isError } = this.state
    const { children } = this.props

    // Display error page (NotFound) when there's an error
    return isError ? <NotFound /> : children
  }
}
